if (!customElements.get('article-share')) {
  class ArticleShare extends HTMLElement {
    constructor() {
      super()
      this.button = this.querySelector('.js-article-share')
      this.url = window.location.href
      this.copyLinkTooltip = this.querySelector('.js-tooltip')
      this.successTooltip = this.querySelector('.js-tooltip-success')
      this.errorTooltip = this.querySelector('.js-tooltip-error')
    }

    connectedCallback() {
      this.attachEvents()
    }

    toggleTooltip(tooltip) {
      tooltip.classList.toggle('is-visible')

      setTimeout(() => {
        tooltip.classList.toggle('is-visible')
      }, 1000)
    }

    attachEvents() {
      this.button.addEventListener('click', () => {
        navigator.clipboard.writeText(this.url).then(
          () => {
            this.toggleTooltip(this.successTooltip)
          },
          (err) => {
            this.toggleTooltip(this.errorTooltip)
          }
        )
      })
    }
  }

  customElements.define('article-share', ArticleShare)
}
